// Two-column code row: a fixed-width shortKey column + the description wrapping
// to at most three lines. Used both in the product editor's selected list and in
// the pushed selection page, so the codes line up and the meaning stays readable.
export default function AllergenCodeRow({
  code,
  description,
}: {
  code: string;
  description?: string;
}) {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'baseline', width: '100%' }}>
      <span style={{ flex: 'none', minWidth: 22, whiteSpace: 'nowrap', fontWeight: 600 }}>
        {code}
      </span>
      {description && (
        <span
          style={{
            flex: 1,
            minWidth: 0,
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            overflow: 'hidden',
          }}
        >
          {description}
        </span>
      )}
    </div>
  );
}
